export function evaluatePasswordPolicy(password) {
  const s = String(password ?? '')
  const minLength8 = s.length >= 8
  const hasUppercase = /[A-Z]/.test(s)
  const hasDigit = /\d/.test(s)
  const hasSymbol = /[^A-Za-z0-9]/.test(s)
  const allMet = minLength8 && hasUppercase && hasDigit && hasSymbol
  return { minLength8, hasUppercase, hasDigit, hasSymbol, allMet }
}

export const PASSWORD_POLICY_ITEMS = Object.freeze([
  { key: 'minLength8', label: 'Al menos 8 caracteres' },
  { key: 'hasUppercase', label: 'Al menos una letra mayúscula' },
  { key: 'hasDigit', label: 'Al menos un número' },
  { key: 'hasSymbol', label: 'Al menos un símbolo' },
])
